import styled from 'styled-components';

export const Grid = styled.div<{
  columns?: number | string;
  gap?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  minColumnWidth?: string;
}>`
  display: grid;
  grid-template-columns: ${({ columns, minColumnWidth }) => {
    if (minColumnWidth) {
      return `repeat(auto-fit, minmax(${minColumnWidth}, 1fr))`;
    }
    if (typeof columns === 'number') {
      return `repeat(${columns}, 1fr)`;
    }
    return columns || 'repeat(auto-fit, minmax(250px, 1fr))';
  }};
  gap: ${({ gap = 'md', theme }) => theme.spacing[gap]};
`;
